import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA,MatDialogModule,MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-credit-report-confirmation',
  standalone: true,
  imports: [CommonModule,SharedModule,MatDialogModule, MatButtonModule],
  templateUrl: './credit-report-confirmation.component.html',
  styleUrl: './credit-report-confirmation.component.scss'
})
export class CreditReportConfirmationComponent implements OnInit {
constructor(
    public dialogRef: MatDialogRef<CreditReportConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private renderer: Renderer2,
  ) {}
  ngOnInit(): void {
    this.renderer.addClass(document.documentElement, 'confirmationPopup-open');
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(document.documentElement, 'confirmationPopup-open');
  }
}
